/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HotelEditGroupHasBreakfastApiRequest } from '../../models/hotel-edit-group-has-breakfast-api-request';

export interface ApiHotelManageEditGroupBreakfastPost$Params {
      body: HotelEditGroupHasBreakfastApiRequest
}

export function apiHotelManageEditGroupBreakfastPost(http: HttpClient, rootUrl: string, params: ApiHotelManageEditGroupBreakfastPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiHotelManageEditGroupBreakfastPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiHotelManageEditGroupBreakfastPost.PATH = '/api/hotel/manage/edit/group/breakfast';
